import { CheckboxVariantType, RadioButtonGroupVariantType, TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, STATE_PROPS) => ({
    content: {
        text: {
            font_variant: TextVariantType.FONT_PARAGRAPH_500,
            font_weight: Number(FOUNDATIONS.font_weight_paragraph_medium_regular),
            ...STATE_PROPS.text,
        },
    },
    checkbox: {
        variant: CheckboxVariantType.REGULAR,
    },
    radioButton: {
        variant: RadioButtonGroupVariantType.REGULAR,
    },
});
//# sourceMappingURL=commonStyles.js.map